import { createAction } from 'redux-actions';

export const PICK_LIVE_MATHS_LEVEL = 'PICK_LIVE_MATHS_LEVEL';
export const RESET_LIVE_MATHS_LEVEL = 'RESET_LIVE_MATHS_LEVEL';

const pickLevel = createAction(PICK_LIVE_MATHS_LEVEL);
const resetLevel = createAction(RESET_LIVE_MATHS_LEVEL);

export default {
    pickLevel,
    resetLevel
};



// WEBPACK FOOTER //
// ./components/live-maths-level-picker/live-maths-level-picker-actions.js